import { useEffect, useState } from 'react';

const usePcH5 = () => {
  const [isPc, setIsPc] = useState(false);
  useEffect(() => {
    if (window.innerWidth > 800) {
      setIsPc(true);
    }
  }, []);
  return [isPc];
};

export default usePcH5;
